import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import reportWebVitals from './reportWebVitals'
import { store, persistor } from './helpers'
import { BrowserRouter } from 'react-router-dom'
import { createRoot } from 'react-dom/client'
// import { AdminApp } from "./admin";

// import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import 'react-confirm-alert/src/react-confirm-alert.css'
// import Main from './Main';

//Import default css react-datetime-picker
import 'react-datetime-picker/dist/DateTimePicker.css'
import 'react-calendar/dist/Calendar.css'
import 'react-clock/dist/Clock.css'
//End Import default css react-datetime-picker
import Main from './Main'

//End import default css coreui

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <React.Suspense fallback={loading}>
          <Main />
        </React.Suspense>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
)

reportWebVitals(console.log)
